module.exports = __webpack_public_path__ + "img/Lorinthe-Logo.1585c03b.svg";